function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6305 9.83467L11.7598 0.840552C11.3266 0.445713 10.6732 0.445756 10.2402 0.840509L0.369446 9.83471C0.0223886 10.151 -0.0922519 10.6382 0.0773025 11.076C0.2469 11.5138 0.659829 11.7967 1.12935 11.7967H2.70587V20.8081C2.70587 21.1654 2.99556 21.4551 3.35285 21.4551H8.7632C9.12049 21.4551 9.41018 21.1655 9.41018 20.8081V15.3367H12.5899V20.8082C12.5899 21.1655 12.8796 21.4552 13.2369 21.4552H18.647C19.0043 21.4552 19.294 21.1655 19.294 20.8082V11.7967H20.8708C21.3403 11.7967 21.7533 11.5138 21.9229 11.076C22.0922 10.6382 21.9776 10.151 21.6305 9.83467Z",
  fill: "#A4B1BC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1242 1.83545H14.7793L19.7712 6.37449V2.48239C19.7712 2.1251 19.4816 1.83545 19.1242 1.83545Z",
  fill: "#A4B1BC"
});

var SvgHomeicon = function SvgHomeicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.icon.8708d923.svg";
export { ForwardRef as ReactComponent };